export default class RFIRecallRequest {
  public comments: string;

  constructor() {
    this.comments = "Enter Note";
  }
}
